module.exports = __webpack_public_path__ + "img/image_callin_tablet.64b87fdd.jpg";